/* tslint:disable */
/* eslint-disable */
/**
 * Bikeleasing Accounts
 * Consumers of the API must follow the tolerant reader pattern. Especially the consumer    * must ignore unknown properties   * expect enumerations to be extended at any time (this includes discriminators)      These changes are considered backwards compatible.   However, we will never do a backwards-incompatible change without creating a new API version:   * removal of required properties   * removal of a supported request parameter   * adding a new required request parameter or attributes   * renaming of an attribute      All responses contain a common header `X-Request-Id` which identifies the individual HTTP request. This ID should be included in any bug reports or support requests.  There is a per-client rate limit on the API. If the rate limit is exceeded (resulting in a \"429 Too Many Requests\" response), please slow down and retry  after a short delay.  The API strives to return status codes that align with user expectations. However, in some error cases, multiple status codes may seem appropriate, and  the expected status code might not be clear. Here are two important points to consider when dealing with error status codes: 1. The API first checks the user\'s permission to access a resource. Only if the user has permission, it attempts to retrieve the resource. As a consequence, a user will     see a `403 Access Denied` status when requesting non-existent single resources since the permission check fails first. 2. There are no permissions on collections, only on the resources contained within them. Therefore, the API never returns a `403 Access Denied` status because the user     lacks permission to access a collection. Instead, the API returns a list containing all resources the user has permission to access. If the user has no permission to any     resource in the collection, an empty list with a `200 OK` status code is returned.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Employee } from '../dto';
// @ts-ignore
import type { EmployeesListResponse } from '../dto';
// @ts-ignore
import type { InlineObject } from '../dto';
// @ts-ignore
import type { InlineObject1 } from '../dto';
// @ts-ignore
import type { PatchDocumentInner } from '../dto';
/**
 * EmployeesApi - axios parameter creator
 * @export
 */
export const EmployeesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Soft deletes the employee with the specified ID. The current state of an employee is also published in Kafka with exactly the same data structure in the `accounts.employee.entity.v1` topic with the `employeeId` header set to the employee ID.
         * @param {string} employeeId The employee identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmployee: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('deleteEmployee', 'employeeId', employeeId)
            const localVarPath = `/api/v1/employees/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["employees:write"], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId The employee identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployee: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getEmployee', 'employeeId', employeeId)
            const localVarPath = `/api/v1/employees/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["employees:read"], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all employees matching the filter.
         * @param {string} [companyId] 
         * @param {number} [pageSize] The maximum number of items per page
         * @param {string} [pageAfter] An opaque cursor specifying the lower, exclusive boundary. The first item in the result list is the item that is immediately after the cursor.  Clients should never set this parameter themselves. But the parameter will be set in the pagination links in the result list. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmployees: async (companyId?: string, pageSize?: number, pageAfter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["employees:read"], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }

            if (pageAfter !== undefined) {
                localVarQueryParameter['page[after]'] = pageAfter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Applies a JSON Patch document to partially update a employee. Only the fields provided in the patch document will be updated; all other fields remain unchanged.  Expected error types for bad requests: - error:account@bikeleasing:context-missing - error:account@bikeleasing:parent-company-not-found - error:account@bikeleasing:invalid-patch-operation 
         * @param {string} employeeId The employee identifier
         * @param {Array<PatchDocumentInner>} patchDocumentInner 
         * @param {string} [ifMatch] The expected version of the resource, as returned in the &#x60;etag&#x60; response. If the version does not match the current version of the resource, a &#x60;412 Precondition Failed&#x60; response is returned.  It is important that the If-Match header encloses the ETag value in double quotes, as specified in [RFC 7232, Section 3.1](https://datatracker.ietf.org/doc/html/rfc7232#section-3.1) to prevent parsing issues.  This header can be used to implement optimistic concurrency control. If not provided, no version check is performed and the update is applied unconditionally. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEmployee: async (employeeId: string, patchDocumentInner: Array<PatchDocumentInner>, ifMatch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('patchEmployee', 'employeeId', employeeId)
            // verify required parameter 'patchDocumentInner' is not null or undefined
            assertParamExists('patchEmployee', 'patchDocumentInner', patchDocumentInner)
            const localVarPath = `/api/v1/employees/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["employees:write"], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (ifMatch != null) {
                localVarHeaderParameter['If-Match'] = String(ifMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchDocumentInner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new employee.  Expected error types for bad requests: - error:account@bikeleasing:parent-company-not-found - error:account@bikeleasing:context-missing 
         * @param {Employee} employee 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEmployee: async (employee: Employee, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employee' is not null or undefined
            assertParamExists('postEmployee', 'employee', employee)
            const localVarPath = `/api/v1/employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["employees:write"], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employee, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeesApi - functional programming interface
 * @export
 */
export const EmployeesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeesApiAxiosParamCreator(configuration)
    return {
        /**
         * Soft deletes the employee with the specified ID. The current state of an employee is also published in Kafka with exactly the same data structure in the `accounts.employee.entity.v1` topic with the `employeeId` header set to the employee ID.
         * @param {string} employeeId The employee identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmployee(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmployee(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.deleteEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} employeeId The employee identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployee(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Employee>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployee(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.getEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all employees matching the filter.
         * @param {string} [companyId] 
         * @param {number} [pageSize] The maximum number of items per page
         * @param {string} [pageAfter] An opaque cursor specifying the lower, exclusive boundary. The first item in the result list is the item that is immediately after the cursor.  Clients should never set this parameter themselves. But the parameter will be set in the pagination links in the result list. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEmployees(companyId?: string, pageSize?: number, pageAfter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEmployees(companyId, pageSize, pageAfter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.listEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Applies a JSON Patch document to partially update a employee. Only the fields provided in the patch document will be updated; all other fields remain unchanged.  Expected error types for bad requests: - error:account@bikeleasing:context-missing - error:account@bikeleasing:parent-company-not-found - error:account@bikeleasing:invalid-patch-operation 
         * @param {string} employeeId The employee identifier
         * @param {Array<PatchDocumentInner>} patchDocumentInner 
         * @param {string} [ifMatch] The expected version of the resource, as returned in the &#x60;etag&#x60; response. If the version does not match the current version of the resource, a &#x60;412 Precondition Failed&#x60; response is returned.  It is important that the If-Match header encloses the ETag value in double quotes, as specified in [RFC 7232, Section 3.1](https://datatracker.ietf.org/doc/html/rfc7232#section-3.1) to prevent parsing issues.  This header can be used to implement optimistic concurrency control. If not provided, no version check is performed and the update is applied unconditionally. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEmployee(employeeId: string, patchDocumentInner: Array<PatchDocumentInner>, ifMatch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Employee>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEmployee(employeeId, patchDocumentInner, ifMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.patchEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new employee.  Expected error types for bad requests: - error:account@bikeleasing:parent-company-not-found - error:account@bikeleasing:context-missing 
         * @param {Employee} employee 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postEmployee(employee: Employee, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Employee>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postEmployee(employee, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeesApi.postEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeesApi - factory interface
 * @export
 */
export const EmployeesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeesApiFp(configuration)
    return {
        /**
         * Soft deletes the employee with the specified ID. The current state of an employee is also published in Kafka with exactly the same data structure in the `accounts.employee.entity.v1` topic with the `employeeId` header set to the employee ID.
         * @param {EmployeesApiDeleteEmployeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmployee(requestParameters: EmployeesApiDeleteEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEmployee(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeesApiGetEmployeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployee(requestParameters: EmployeesApiGetEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Employee> {
            return localVarFp.getEmployee(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all employees matching the filter.
         * @param {EmployeesApiListEmployeesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmployees(requestParameters: EmployeesApiListEmployeesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EmployeesListResponse> {
            return localVarFp.listEmployees(requestParameters.companyId, requestParameters.pageSize, requestParameters.pageAfter, options).then((request) => request(axios, basePath));
        },
        /**
         * Applies a JSON Patch document to partially update a employee. Only the fields provided in the patch document will be updated; all other fields remain unchanged.  Expected error types for bad requests: - error:account@bikeleasing:context-missing - error:account@bikeleasing:parent-company-not-found - error:account@bikeleasing:invalid-patch-operation 
         * @param {EmployeesApiPatchEmployeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEmployee(requestParameters: EmployeesApiPatchEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Employee> {
            return localVarFp.patchEmployee(requestParameters.employeeId, requestParameters.patchDocumentInner, requestParameters.ifMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new employee.  Expected error types for bad requests: - error:account@bikeleasing:parent-company-not-found - error:account@bikeleasing:context-missing 
         * @param {EmployeesApiPostEmployeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEmployee(requestParameters: EmployeesApiPostEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Employee> {
            return localVarFp.postEmployee(requestParameters.employee, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteEmployee operation in EmployeesApi.
 * @export
 * @interface EmployeesApiDeleteEmployeeRequest
 */
export interface EmployeesApiDeleteEmployeeRequest {
    /**
     * The employee identifier
     * @type {string}
     * @memberof EmployeesApiDeleteEmployee
     */
    readonly employeeId: string
}

/**
 * Request parameters for getEmployee operation in EmployeesApi.
 * @export
 * @interface EmployeesApiGetEmployeeRequest
 */
export interface EmployeesApiGetEmployeeRequest {
    /**
     * The employee identifier
     * @type {string}
     * @memberof EmployeesApiGetEmployee
     */
    readonly employeeId: string
}

/**
 * Request parameters for listEmployees operation in EmployeesApi.
 * @export
 * @interface EmployeesApiListEmployeesRequest
 */
export interface EmployeesApiListEmployeesRequest {
    /**
     * 
     * @type {string}
     * @memberof EmployeesApiListEmployees
     */
    readonly companyId?: string

    /**
     * The maximum number of items per page
     * @type {number}
     * @memberof EmployeesApiListEmployees
     */
    readonly pageSize?: number

    /**
     * An opaque cursor specifying the lower, exclusive boundary. The first item in the result list is the item that is immediately after the cursor.  Clients should never set this parameter themselves. But the parameter will be set in the pagination links in the result list. 
     * @type {string}
     * @memberof EmployeesApiListEmployees
     */
    readonly pageAfter?: string
}

/**
 * Request parameters for patchEmployee operation in EmployeesApi.
 * @export
 * @interface EmployeesApiPatchEmployeeRequest
 */
export interface EmployeesApiPatchEmployeeRequest {
    /**
     * The employee identifier
     * @type {string}
     * @memberof EmployeesApiPatchEmployee
     */
    readonly employeeId: string

    /**
     * 
     * @type {Array<PatchDocumentInner>}
     * @memberof EmployeesApiPatchEmployee
     */
    readonly patchDocumentInner: Array<PatchDocumentInner>

    /**
     * The expected version of the resource, as returned in the &#x60;etag&#x60; response. If the version does not match the current version of the resource, a &#x60;412 Precondition Failed&#x60; response is returned.  It is important that the If-Match header encloses the ETag value in double quotes, as specified in [RFC 7232, Section 3.1](https://datatracker.ietf.org/doc/html/rfc7232#section-3.1) to prevent parsing issues.  This header can be used to implement optimistic concurrency control. If not provided, no version check is performed and the update is applied unconditionally. 
     * @type {string}
     * @memberof EmployeesApiPatchEmployee
     */
    readonly ifMatch?: string
}

/**
 * Request parameters for postEmployee operation in EmployeesApi.
 * @export
 * @interface EmployeesApiPostEmployeeRequest
 */
export interface EmployeesApiPostEmployeeRequest {
    /**
     * 
     * @type {Employee}
     * @memberof EmployeesApiPostEmployee
     */
    readonly employee: Employee
}

/**
 * EmployeesApi - object-oriented interface
 * @export
 * @class EmployeesApi
 * @extends {BaseAPI}
 */
export class EmployeesApi extends BaseAPI {
    /**
     * Soft deletes the employee with the specified ID. The current state of an employee is also published in Kafka with exactly the same data structure in the `accounts.employee.entity.v1` topic with the `employeeId` header set to the employee ID.
     * @param {EmployeesApiDeleteEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public deleteEmployee(requestParameters: EmployeesApiDeleteEmployeeRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).deleteEmployee(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeesApiGetEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getEmployee(requestParameters: EmployeesApiGetEmployeeRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getEmployee(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all employees matching the filter.
     * @param {EmployeesApiListEmployeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public listEmployees(requestParameters: EmployeesApiListEmployeesRequest = {}, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).listEmployees(requestParameters.companyId, requestParameters.pageSize, requestParameters.pageAfter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Applies a JSON Patch document to partially update a employee. Only the fields provided in the patch document will be updated; all other fields remain unchanged.  Expected error types for bad requests: - error:account@bikeleasing:context-missing - error:account@bikeleasing:parent-company-not-found - error:account@bikeleasing:invalid-patch-operation 
     * @param {EmployeesApiPatchEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public patchEmployee(requestParameters: EmployeesApiPatchEmployeeRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).patchEmployee(requestParameters.employeeId, requestParameters.patchDocumentInner, requestParameters.ifMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new employee.  Expected error types for bad requests: - error:account@bikeleasing:parent-company-not-found - error:account@bikeleasing:context-missing 
     * @param {EmployeesApiPostEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public postEmployee(requestParameters: EmployeesApiPostEmployeeRequest, options?: RawAxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).postEmployee(requestParameters.employee, options).then((request) => request(this.axios, this.basePath));
    }
}

